import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "organisation-label label label-default"
}
const _hoisted_2 = { key: 1 }

import {
  OrganisationDescriptionApiModel,
  ShortOrganisationDetailsApiModel,
} from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-label',
  props: {
    value: {},
    emptyText: { default: "" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.value.name), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.emptyText), 1))
  ]))
}
}

})